import { Standard } from "./standard";

export class SelectedStandard {
  standard: any = new Standard();
  isFirst: boolean;
  isLast: boolean;
  isInNrbes: boolean;
  keyContact?: any;
  links?: any[];
  addendum: any[] = [];

  constructor(obj?: any) {
    if (obj) {
      this.standard = new Standard(obj.standard);
      this.isFirst = obj.isFirst;
      this.isLast = obj.isLast;
      this.isInNrbes = obj.isInNrbes;
      this.keyContact = obj.keyContact ?? obj.KeyContact ?? obj.standard?.keyContact ?? obj.standard?.KeyContact;
      this.links = obj.links ?? obj.Links ?? obj.standard?.links ?? obj.standard?.Links;
      this.addendum = obj.addendum ?? obj.Addendum ?? [];
    }
  }
}
